import { useRef } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

import { useFocusTrap } from '../hooks/useFocusTrap'
import { SHORTCUT_HELP } from '../hooks/useShortcuts'

/**
 * Kisayol yardimi (`Ctrl/⌘ + /`).
 *
 * Kisayollar KESFEDILEBILIR olmali: hicbir yerde listelenmeyen bir kisayol,
 * yalnizca onu yazan kisinin bildigi bir ozellik. `<kbd>` kullaniliyor -
 * anlamsal olarak dogru oge ve ekran okuyucu onu "tus" olarak duyuruyor.
 */
export function ShortcutHelp({ onClose }: { onClose(): void }) {
  const { t } = useTranslation()
  const container = useRef<HTMLDivElement>(null)
  useFocusTrap(container, { active: true, onClose })

  return createPortal(
    <div
      className="modal-backdrop"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose()
      }}
    >
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="shortcuts-title"
        ref={container}
        tabIndex={-1}
      >
        <h2 id="shortcuts-title">{t('shortcuts.title')}</h2>
        <dl className="shortcut-list">
          {SHORTCUT_HELP.map((item) => (
            <div key={item.keys} className="shortcut-row">
              <dt>
                <kbd>{item.keys}</kbd>
              </dt>
              {/* `item.action` bir ceviri ANAHTARI: liste modul seviyesinde
                  ve orada `t()` cagirmak, dil degistiginde guncellenmeyen
                  donmus metinler uretirdi. */}
              <dd>{t(item.action)}</dd>
            </div>
          ))}
        </dl>
        <button type="button" className="btn-primary" onClick={onClose}>
          {t('common.close')}
        </button>
      </div>
    </div>,
    document.body,
  )
}
